/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Button, getPayloadObject, getTelemetryAttributes, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IBusinessSignUpButtonProps {
    id?: string;
    className: string;
    text: string;
    ariaLabel: string;
    disabled?: boolean;
    link?: string;
    telemetryContent: ITelemetryContent;
    onClick?(event: React.MouseEvent<HTMLElement>): void;
}

export const SignUpButton: React.FC<IBusinessSignUpButtonProps> = ({ id, className, text, ariaLabel, telemetryContent, disabled, link, onClick }) => {
    const payLoad = getPayloadObject('click', telemetryContent, text);
    const attributes = getTelemetryAttributes(telemetryContent, payLoad);
    return (
        <Button
            id={id}
            className={className}
            aria-label={ariaLabel}
            disabled={disabled}
            onClick={onClick}
            role='button'
            aria-disabled={disabled}
            href={link}
            {...attributes}
        >
            {text}
        </Button>
    );
};

export default SignUpButton;
